import React, { useState, useContext, useEffect } from 'react';
import '../../../styles/casedetails.css';
import { Outlet, Link, useNavigate, Navigate } from 'react-router-dom';
import { ShareContext } from '../../../context/ShareContext'
import * as Constants from '../../../constants';
import JisButton from '../../controls/jisButton';
import DynamicIcon from '../../dynamicicon';
import JisDialogForm from '../../formdialog';
import PdfViewer from '../../controls/pdfviewer';

function ViewDocuments({caseId, documents, isAction=false}) {
  
  const navigate = useNavigate()
     const {  activePage, token, profile,frequentData} = useContext(ShareContext);
     const [loading, setLoading] =useState(false);
    const onFilingDocument=()=>{
      navigate(`/filing-document/${caseId}`);
    } 
    const [isPreview, setIsPreview] = useState(false);
    const [previewUrl, setPreviewUrl] =  useState(false);
   const onDownload= async(doc)=>{ //doctype=upline always this one
    //for account registration DocumentView
    const url=`${Constants.apiUrl}/filing/downloadcasedocument/${doc.id}`

    console.log(`the calling url ${url}`);
    try {
        setLoading(true);
        const resp = await fetch(url, { 
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'responseType': 'blob'
          },
        });
        
        const data = await resp.blob();
        setLoading(false);
        console.log('specific document');
        const blob = new Blob([data], {type: 'application/pdf'});
            const link = document.createElement('a');
            link.download =doc.filename;// 'some.pdf';
            link.href = URL.createObjectURL(blob);
            link.click();
      } catch (error) {
        setLoading(false);
        console.error(error);
        
      }
}
const onPreviewDoc =(docs)=>{
        setIsPreview(true);
      console.log(docs);
        console.log('here is called');
        var finalpath='';
                if(docs.documentLocation!=null){
                  finalpath= Constants.RelativeFiletoRelative(`${docs.documentLocation}/${docs.filename}`  );
                }else{
                   finalpath=`${Constants.baseurl}/template-live-document/${docs.id}`
                }
        setPreviewUrl(finalpath )

    }
  return (
    <div>
   {isAction &&   <div style={{textAlign:'right'}}>
<JisButton onClick={onFilingDocument}>
        CLICK HERE TO FILE ADDITIONAL DOCUMENT(S)
       </JisButton>
      </div>}  
       
<div  className='table'>
        <div class="section-cases">
          <span>Case Documents</span>
        </div>


        <table className='case-table'>
          <thead>
            <tr>
              <th>Title</th>
              
              <th>Party</th>
              <th>Filed On</th>
              <th>Download</th>
              <th>Preview</th>
            </tr>
          </thead>
          <tbody>
           {documents?.map((opt) => ( 
               <tr>
              <td>{opt.title}</td>
             
             {opt.party!=null ?<td> {opt.party?.firstName} {opt.party?.lastName??''}</td>:<td>{opt.doneBy?.firstName} {opt.doneBy?.lastName??''}</td>}  
              <td>{Constants.momentDate(opt.createdOn).format('DD MMM, YYYY')}</td>
              {opt.documentLocation!="template"? <td className='schedule-zoom' onClick={() => onDownload(opt) }> Download <DynamicIcon iname='download' /> </td>
                                      : <td className='schedule-zoom'>  <Link target='_blank' to={`/template-live-document/${opt.id}`}>Print/Save <DynamicIcon iname='print' /> </Link></td>} 
              <td><JisButton onClick={()=>onPreviewDoc(opt)}>Preview</JisButton></td>
            </tr>
              
            ))}
          </tbody>
        </table>
      </div>

   {isPreview && previewUrl!='' && <JisDialogForm title="Document Preview" onClose={() =>setIsPreview(false)}>
          <div>
            <div style={{height:'90vh'}}> <PdfViewer pdfUrl={previewUrl}/>
                               
                                </div>
          </div>
</JisDialogForm>}       
    </div>
  );
}

export default ViewDocuments;
